/**
 * AWARE Health Frontend — Root Application Component
 * Wraps the app with Theme, ViewMode providers and renders the Dashboard.
 */

import { ThemeProvider } from './contexts/ThemeContext'
import { ViewModeProvider } from './contexts/ViewModeContext'
import Dashboard from './pages/Dashboard'

export default function App() {
  return (
    <ThemeProvider>
      <ViewModeProvider>
        <Dashboard />
      </ViewModeProvider>
    </ThemeProvider>
  )
}
